export enum PermitListType {
    Ongoing = 1,
    Planned = 2,
    Completed = 3,
}
